var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { "open-delay": "750", bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-chip",
                _vm._g(
                  {
                    staticClass: "px-1 cp",
                    attrs: { "x-small": "", color: _vm.color, label: "" },
                  },
                  on
                ),
                [
                  _c("span", { staticClass: "text--primary" }, [
                    _vm._v(_vm._s(_vm.label)),
                  ]),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("span", { staticClass: "tooltip-content" }, [
        _vm._v(_vm._s(_vm.tooltip)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }